import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import api from "../../../api/api";
import '../styles/TeacherPanel.css';

// Icons
import dashboardIcon from '../icons/dashboard.png';
import logoutIcon from '../icons/logout.png';
import notificationsIcon from '../icons/notifications.png';
import resultsIcon from '../icons/results.png';
import classIcon from '../icons/class.png';
import teacherIcon from '../icons/teacher.svg';
import classworkIcon from '../icons/classwork.png';
import homeworkIcon from '../icons/homework.svg';
import assignmentIcon from '../icons/assignment.svg';
import attendanceIcon from '../icons/attendance.png';

const iconMap = {
  'Teacher Dashboard': teacherIcon,
  'Teacher Attendance': attendanceIcon,
  'Notifications': notificationsIcon,
  'Results': resultsIcon,
  'Update Class Work': classworkIcon,
  'Update Home Work': homeworkIcon,
  'Update Assignment': assignmentIcon,
  'Schedule Class': classIcon,
};

const TeacherPanel = ({ onToggle, hideToggle = false }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activePath, setActivePath] = useState(location.pathname);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [modules, setModules] = useState([]);

  const teacherId = localStorage.getItem('userId');
  const token = localStorage.getItem('token');
  const schoolId = localStorage.getItem("schoolId") || "";

  // Fetch enabled teacher modules
  useEffect(() => {
    const fetchModules = async () => {
      try {

        if (!token || !schoolId) return;

        const res = await api.get(`/api/modules/${schoolId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });

       const enabledModules = res.data.filter(
  (m) => m.role === 'teacher' && m.enabled
);

        setModules(enabledModules);

      } catch (err) {
        console.error('Error fetching modules:', err);
      }
    };

    fetchModules();
  }, [token, schoolId]);

  const handleNavigate = (path) => {
    setActivePath(path);
    navigate(path);
    if (window.innerWidth <= 768) document.querySelector('.teacher-panel').classList.remove('expanded');
  };

  const handleLogout = () => {
    const role = localStorage.getItem('role') || 'teacher';
    localStorage.clear();
    navigate(`/portal/${role}`);
  };

  const toggleSidebar = () => {
    const panel = document.querySelector('.teacher-panel');
    if (window.innerWidth <= 768) panel.classList.toggle('expanded');
    else {
      setIsCollapsed(!isCollapsed);
      if (onToggle) onToggle(!isCollapsed);
    }
  };

  return (
    <div className="teacher-panel-wrapper">
      {!hideToggle && (
        <div className={`toggle-button-outside ${isCollapsed ? 'collapsed' : ''}`} onClick={toggleSidebar}>
          <div className="bar"></div>
          <div className="bar"></div>
          <div className="bar"></div>
        </div>
      )}

      <div className={`teacher-panel ${isCollapsed ? 'collapsed' : ''}`}>
        <div className="teacher-panel-header">
          <div className="panel-header-overlay">
            {!isCollapsed && <span className="header-title">Teacher Panel</span>}
          </div>
        </div>

        <div className="teacher-list">
          {modules.map((mod) => {
            const path = mod.path.replace(':id', teacherId);

            return (
              <button
               key={mod.school_module_id}
                className={activePath === path ? 'active' : ''}
                onClick={() => handleNavigate(path)}
              >
                <img
                  src={iconMap[mod.name] || dashboardIcon}
                  alt={mod.name}
                  className={`icon ${activePath === path ? 'active-icon' : ''}`}
                />

                {!isCollapsed && (
                  <span className="teacher-button-content">
                    {mod.name}
                    <span className="teacher-arrow">&gt;</span>
                  </span>
                )}
              </button>
            );
          })}

          <button onClick={handleLogout}>
            <img src={logoutIcon} alt="Logout" className="icon" />

            {!isCollapsed && (
              <span className="teacher-button-content">
                Logout
                <span className="teacher-arrow">&gt;</span>
              </span>
            )}
          </button>

        </div>
      </div>
    </div>
  );
};

export default TeacherPanel;